// src/app/api/apiSlice.js
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "User",
    "Upload",
    "About",
    "Campaigns",
    "Subscribers",
    "Subscription",
    "AdminAlerts",
    "EmailSub",
    "Activities",
    "Notification",
    "MyList",
    "Product",
    "Comment",
    "Reply",
    "Checkout",
    "Faq",
    "Video",
    "VideoCategory",
  ],
  endpoints: () => ({}), // Leave empty, extend with injectEndpoints
});
